import { render, staticRenderFns } from "./_Payment.vue?vue&type=template&id=2a8dbeee&scoped=true"
import script from "./_Payment.vue?vue&type=script&lang=js"
export * from "./_Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dbeee",
  null
  
)

export default component.exports